import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TableCheckboxFilter_Add, TableCheckboxFilter_Delete, TableCheckboxFilter_Update, TableInputContainFilter_Add, TableInputContainFilter_Update, TableSubRangeFilter_Update } from '../../Redux/actions/actionNames';
import { useTranslation } from 'react-i18next';




export function GetTableSubCheckboxFilter(selector,sub, PureList, converter) {
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);

  const pureData = useSelector((state) => state.Table.filters[selector][sub])
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();


  useEffect(() => {

    if (PureList) {
      let xx = []
      //{ key: "1", value: "1" }
      // setData({value : pureData[index].text})
      if (converter) {
        xx = converter(PureList)
        setList(xx)
      } else {
        PureList.forEach(element => {
          xx.push({ key: element.id, value: element.title })
        }); 
        setList(xx)
      }


    }

  }, [PureList]);

  useEffect(() => {

    if (pureData) {
      setData(pureData)
    }

  }, []);

  useEffect(() => {

    if (pureData) {
      setData(pureData)
    }

  }, [pureData]);


  const OnChange = React.useCallback((e) => {
    dispatch(TableSubRangeFilter_Update({ key: selector, sub :sub , value: e }))

  }, [data, pureData, selector , sub]);


  return { [`${selector}${sub}_data`]: data, [`${selector}${sub}_OnChange`]: OnChange, [`${selector}${sub}_list`]: list };
};

